import React from "react";

function inline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**")
      ? <strong key={i} className="font-semibold text-forest">{p.slice(2, -2)}</strong>
      : <React.Fragment key={i}>{p}</React.Fragment>
  );
}

export function ManualContent({ text }) {
  const lines = (text || "").split("\n");
  const blocks = [];
  let bullets = [];
  const flush = () => {
    if (bullets.length) {
      blocks.push(<ul key={`ul-${blocks.length}`} className="my-2 ml-5 list-disc space-y-1 text-forest/80">{bullets}</ul>);
      bullets = [];
    }
  };
  lines.forEach((raw, i) => {
    const l = raw.trimEnd();
    if (l.startsWith("## ")) { flush(); blocks.push(<h3 key={i} className="mt-4 font-heading text-base font-semibold text-forest">{inline(l.slice(3))}</h3>); }
    else if (l.startsWith("# ")) { flush(); blocks.push(<h2 key={i} className="mt-5 font-heading text-xl font-semibold text-forest">{inline(l.slice(2))}</h2>); }
    else if (l.startsWith("- ")) { bullets.push(<li key={i}>{inline(l.slice(2))}</li>); }
    else if (l.trim() === "") { flush(); }
    else { flush(); blocks.push(<p key={i} className="my-1.5 text-sm leading-relaxed text-forest/80">{inline(l)}</p>); }
  });
  flush();
  return <div data-testid="manual-content">{blocks}</div>;
}
